module.exports = __webpack_public_path__ + "static/img/cp_5.bb063ce.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/cp_5.png
// module id = ixu3
// module chunks = 0